module.exports = __webpack_public_path__ + "static/integration_bg-8f8168910bd09d6b5596d3d7d915ac52.webp";